














































































// Utils
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { validationMixin } from 'vuelidate'
import { saveAs } from 'file-saver'
import EventBus from '@/event-bus'
// Validations
import validations from '@/validations/documents'
// Components
import InputFile from '@/components/InputFile.vue'
// Types
import CompanyTypes from '@/store/types/CompanyTypes'
// Services
import Documents from '@/services/Documents'
import Company from '@/services/Company'

@Component({
  mixins: [validationMixin],
  validations: validations,
  components: { InputFile }
})
export default class ModalApprovedOrRejectDocument extends Vue {
  replaceOrUpload = false
  showModal = false;
  approved = false;
  reject = false;
  confirmApproved = false;
  rejectedCategory = '';
  document: any = {};
  rejectionCategories = []
  withDocumentReplace = true
  file = ''
  commissaryName = ''

  @Watch('showModal')
  updateRejectionCategories () {
    if (!this.showModal) return
    this.getRejectionCategories()
  }

  mounted () {
    EventBus.$on('open-modal', (document: any) => {
      this.withDocumentReplace = document.document_url
      this.replaceOrUpload = !document.document_url
      this.showModal = true
      this.approved = false
      this.reject = false
      this.confirmApproved = false
      this.rejectedCategory = ''
      this.document = document
    })
  }

  get isReject () {
    return this.reject
  }

  get isApprove () {
    return this.approved
  }

  async getRejectionCategories () {
    this.loading(true)
    const [error, response] = await Documents.getRejectionCategories(this.document.type)
    this.loading(false)
    if (error) return this.$toasted.global.error(error)
    this.rejectionCategories = response.data
  }

  async approveOrReject () {
    if (this.document.owner_category === 'company') this.approveOrRejectDocumentCompany()
    else if (this.document.owner_category === 'partner') this.approveOrRejectDocumentPartner()
  }

  async approveOrRejectDocumentPartner () {
    this.loading(true)
    const [error] = await Documents.approvedDocument(this.document.partner.id, {
      document_type: this.document.type,
      is_approved: this.approved ? 1 : 0,
      rejection_category: this.reject ? this.rejectedCategory : 'None',
      company_id: this.document.company_id
    })
    if (error) {
      this.loading(false)
      return this.$toasted.global.error(error)
    }
    this.showModal = false
    this.$toasted.global.success({ message: 'Se actualizo el estatus del documento' })
    const [err] = await this.setCompanyData(this.company.id)
    this.loading(false)
    if (err) return this.$toasted.global.error(error)
  }

  async approveOrRejectDocumentCompany () {
    this.loading(true)
    const [error] = await Documents.approvedOrRejectDocumentCompany(this.company.id, {
      document_type: this.document.type,
      is_approved: this.approved,
      rejection_category: this.reject ? this.rejectedCategory : null
    })
    if (error) {
      this.loading(false)
      return this.$toasted.global.error(error)
    }
    if (this.approved && this.document.type === 'commissary_national_identity') {
      const [error2] = await Company.setCommissaryName(this.company.id, this.commissaryName)
      if (error2) {
        this.loading(false)
        return this.$toasted.global.error(error2)
      }
    }
    this.showModal = false
    this.$toasted.global.success({ message: 'Se actualizo el estatus del documento' })
    const [err] = await this.setCompanyData(this.company.id)
    this.loading(false)
    if (err) return this.$toasted.global.error(error)
  }

  async download () {
    this.loading(true)
    const [error, response] = await Documents.getDocument({
      entity_type: this.document.owner_category,
      identity: (this.document.owner_category === 'partner') ? this.document.partner.id : this.document.company_id,
      document_type: this.document.type || this.document.document_type
    })
    this.loading(false)
    if (error) return this.$toasted.global.error(error)
    const fileType = response.headers['content-type'].split('/')[1]
    const blob = new Blob([response.data])
    if (this.document.owner_category === 'company') {
      saveAs(blob, `${this.document.label}.${fileType}`)
    } else if (this.document.owner_category === 'partner') {
      saveAs(blob, `${this.document.partner.name}_${this.document.type}.${fileType}`)
    } else {
      saveAs(blob, `${this.document.owner_category}.${fileType}`)
    }
  }

  async replaceOrUploadDocument () {
    this.loading(true)
    const [error] = await Documents.uploadDocument({
      entity_type: this.document.owner_category,
      identity: (this.document.owner_category === 'company') ? this.document.company_id : this.document.partner.id,
      document_type: this.document.type,
      image: this.file,
      is_approved: this.document.is_approved ? 'yes' : 'no',
      company_id: this.company.id
    })
    if (error) {
      this.loading(false)
      return this.$toasted.global.error(error)
    }
    this.showModal = false
    this.$toasted.global.success({ message: 'Se actualizo la información con éxito' })
    const [err] = await this.setCompanyData(this.company.id)
    this.loading(false)
    if (err) return this.$toasted.global.error(error)
  }

  @Action('UPDATE_STATE_LOADING') loading: any
  @Getter(`CompanyModule/${CompanyTypes.getters.GET_DATA}`) company: any
  @Action(`CompanyModule/${CompanyTypes.actions.UPDATE_DATA}`) setCompanyData: any
}
